export default __webpack_public_path__ + "static/media/diar_ihza_cv.b5ccd36a.pdf";